/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES 料金システム用 API
 * PR TIMES 料金システムで使うAPI。
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ConfirmBookingPlan
 */
export interface ConfirmBookingPlan {
    /**
     * プランID
     * @type {string}
     * @memberof ConfirmBookingPlan
     */
    id: string;
    /**
     * プラン名
     * @type {string}
     * @memberof ConfirmBookingPlan
     */
    name: string;
    /**
     * 料金ラベル
     * @type {string}
     * @memberof ConfirmBookingPlan
     */
    priceLabel: string;
    /**
     * プランの開始日
     * @type {string}
     * @memberof ConfirmBookingPlan
     */
    startDate: string;
    /**
     * プランの終了日
     * @type {string}
     * @memberof ConfirmBookingPlan
     */
    endDate: string | null;
    /**
     * 自動更新
     * @type {boolean}
     * @memberof ConfirmBookingPlan
     */
    isAutoRenewable: boolean;
    /**
     * 一括支払い
     * @type {boolean}
     * @memberof ConfirmBookingPlan
     */
    isLumpSumPayment: boolean;
}

export function ConfirmBookingPlanFromJSON(json: any): ConfirmBookingPlan {
    return ConfirmBookingPlanFromJSONTyped(json, false);
}

export function ConfirmBookingPlanFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConfirmBookingPlan {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'priceLabel': json['price_label'],
        'startDate': json['start_date'],
        'endDate': json['end_date'],
        'isAutoRenewable': json['is_auto_renewable'],
        'isLumpSumPayment': json['is_lump_sum_payment'],
    };
}

export function ConfirmBookingPlanToJSON(value?: ConfirmBookingPlan | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'price_label': value.priceLabel,
        'start_date': value.startDate,
        'end_date': value.endDate,
        'is_auto_renewable': value.isAutoRenewable,
        'is_lump_sum_payment': value.isLumpSumPayment,
    };
}

